import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { useRef} from "react";
import Slider from "react-slick";

export default function HomeTeam() {
    const sliderRef = useRef(null);
    
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
        draggable: false,   
        swipe: false, 
        responsive: [
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };


    const settings2 = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,   
        swipe: false, 
        responsive: [
        {
            breakpoint: 99999,
            settings: "unslick",
        },
        {
            breakpoint: 767,
            settings: { slidesToShow: 2 },
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2 },
        },
        ],
    };

  return (
    <>
    <div className="home-team">
        <div className="container">
            <div className="row justify-content-center">  

                <div className="col-lg-12">
                    <div className="hometeam-head">
                        <h4 className="heading">Our Team</h4>
                        {/* <Link to="" className="arrow-button">Meet The Team <Icons name="Longarrow_right"/></Link> */}
                    </div> 
                </div>

                <div className="col-lg-10">
                    <Tab.Container defaultActiveKey="year-tab1">
                        <Nav className="teamtab-link">
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab1">Founding Members</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab2">Team Members</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="year-tab3">Group</Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className="yearstab-content">
                            <Tab.Pane eventKey="year-tab1">
                                <p className="teamslider-title">Showcasing the Masterminds Behind Saysha</p>

                                <Slider {...settings} ref={sliderRef} className="team-slider">
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Jitender Juneja</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="teambox">
                                            <img src="/image/woodphoto-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Wooden Flooring Collection</p>
                                        </div>
                                    </div> */}

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Umesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Mukesh Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Manoj Kumar</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/teamphoto-5.webp" loading="lazy" className="img-responsive" alt="team"/>
                                            <p>Sunil Malviya</p>
                                            <span>Co-Founder</span>
                                        </div>
                                    </div>
                                </Slider>
                            </Tab.Pane>

                            <Tab.Pane eventKey="year-tab2">
                                <p className="teamslider-title">The People Who Turn Saysha’s Vision into Reality</p>
                                
                                <div className="fadeimage-slider">
                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-1.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-2.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-3.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-4.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-5.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-6.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-7.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-8.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-9.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-10.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-11.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-12.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-13.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-14.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>

                                    <div className="fadeimage-card">
                                        <div className="fade-container">
                                            <img src="/image/planning-team-15.webp" className="fade-img img1" alt="team" />
                                            <img src="/image/planning-team-16.webp" className="fade-img img2" alt="team" />
                                        </div>
                                    </div>
                                </div>

                                <Slider {...settings2} ref={sliderRef} className="team-slider member-team">
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-1.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>
                                    
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-2.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-3.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-4.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-5.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-6.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-7.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-8.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-9.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>
                                    
                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-10.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-11.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-12.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-13.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-14.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-15.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="teambox">
                                            <img src="/image/planning-team-16.webp" loading="lazy" className="img-responsive" alt="team"/>
                                        </div>
                                    </div>
                                </Slider>
                            </Tab.Pane>

                            <Tab.Pane eventKey="year-tab3">
                                <p className="teamslider-title">A Team Built on Vision, Craft, and Saysha</p>
                                
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                         <img src="/image/groupphoto-1.webp" loading="lazy" className="img-responsive radius-8" alt="team"/>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                         <img src="/image/groupphoto-2.webp" loading="lazy" className="img-responsive radius-8 group-photo" alt="team"/>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>

            </div>
        </div>
    </div> 
    </>
  )
}
